import React from "react";
import { DckActionCreators, DckSelectors } from "dck-redux";
import * as ItemTypes from "../../redux/items/types";
import { connect } from "react-redux";
import FormCharge from "./Form";

class UpdateCharge extends React.Component {

  componentDidMount() {
    const { params, setCurrentChargeId, loadCharges, charge } = this.props;
    setCurrentChargeId(params.id);
    if(!charge) {
      loadCharges();
    }
  }

  render() {
    const { charge } = this.props;
    return charge ? <FormCharge charge={ charge } /> : <p>Loading ..</p>
  }
}

const mapStateToProps = (state, ownProps) => {
  const charge = DckSelectors.selectItemById(state, ItemTypes.Charges, ownProps.params.id);
  return { charge };
}

const mapDispatchToProps = dispatch => ({
  setCurrentChargeId: id => dispatch(DckActionCreators.itemMakeActive(ItemTypes.Charges, id)),
  loadCharges: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Charges)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UpdateCharge)



// WEBPACK FOOTER //
// ./src/components/Charges/UpdateCharge.js